import { syncLoadAlertsAndAssets } from './application-core.js';
import { updateGraph } from './components/graph/graph-helpers.js';
import { drawChartFor } from './components/graph/graph.js';
var shift_y = 0;
var shift_x = 0;
$(document).on("scroll", function (e) {
	let y = window.scrollY * 0.1;
	//document.documentElement.style.setProperty('--lp-background-y', y);
	shift_y = y;
});

$("#main-wrapper-landingpage").on("mousemove", function (e) {
	let x = (-e.clientX / innerWidth * 10) + 5;
	shift_x = x;

	//	let rotateY = (e.clientX / innerWidth * 0.1 - 0.05);
	//	if (rotateY<0) rotateY = 360+rotateY; 
	//	rotateY+="deg";
	//document.documentElement.style.setProperty('--lp-rotate-y', rotateY);
	//$(".start-screen").css("transition", "none");
})

$(document).on('turbolinks:load', function () {
	$('[data-toggle="tooltip"]').tooltip({
		placement: 'top'
	});
});

$(document).on('turbolinks:load', function () {
	$(".preloader").fadeOut();
});

var canvas_imgs = [];


export function animate() {
	requestAnimationFrame(animate);
	var canvas = document.getElementById('start-animation-canvas');

	if (canvas) {
		var ctx = canvas.getContext('2d');
		ctx.clearRect(0, 0, canvas.width, canvas.height);

		var x_scaler = 10;
		var y_scaler = 0.75;

		for (var i = 0; i < 9; i++) {
			switch (i) {
				case 0:
					x_scaler = 10;
					y_scaler = 0.75;
					break;
				case 1:
					x_scaler = 6;
					y_scaler = 0.85;
					break;
				case 2:
					x_scaler = 3.6;
					y_scaler = 0.95;
					break;
				case 3:
					x_scaler = 3;
					y_scaler = 1;
					break;
				case 4:
					x_scaler = 2.2;
					y_scaler = 1;
					break;
				case 5:
					x_scaler = 2;
					y_scaler = 1;
					break;
				case 6:
					x_scaler = 1.7;
					y_scaler = 1;
					break;
				case 7:
					x_scaler = 1.2;
					y_scaler = 1;
					break;
				case 8:
					x_scaler = 1;
					y_scaler = 1;
					break;
			}

			if (canvas_imgs[i]) 
			ctx.drawImage(canvas_imgs[i], shift_x * x_scaler, -shift_y * y_scaler, 1100 + parseFloat(shift_x) * x_scaler, 1500 - parseFloat(shift_y) * y_scaler);

		}
	}

}

var refmobint = null;

$(document).ready(function () {

	setTimeout(function () {
		for (var i = 2; i < 10; i++) {
			canvas_imgs[i - 2] = new Image();
			canvas_imgs[i - 2].src = "/assets/background/webp/wave01_0140" + i + ".webp";
		}
		canvas_imgs[8] = new Image();
		canvas_imgs[8].src = "/assets/background/webp/wave01_01410.webp";

		animate();
	}, 500);

	let ver = msieversion();

	if (!ver) {
	}
	if (ver) {
		alert("You are using IExplorer " + ver + ". Wavealert will probably not work this way. Please use an other web browser instead! Thank you!");
	}

	$(".language-selection").each(function () {
		if ($(this).css("display") == "block") {
			$(this).css("display", "none");
			$(this).css("opacity", "1");
			$(this).fadeIn(400);
		}
	});

	/* start service worker 
		check if saveMobileSubscription exists (ionic app)
		or
		sw_main works (then it is non ionic app but browser push subscriptions instead)
	*/

	var loggedin = window.loggedin || '0';
	if (loggedin == '1') {
		refmobint = setInterval(
			function () {
				saveMobileSubscriptionAjax(
					mobilesubscriptionsData.ep,
					mobilesubscriptionsData.key,
					refmobint
				);
			}, 2000);

		if (typeof sw_main === 'function') {
			sw_main();
			cancelSubscriptionLoop();
		}

	}
	else {
		if (typeof unregisterServiceWorkers === "function")
			unregisterServiceWorkers();
	}

	/* if all alerts up not up to date */
	/* first get my portfolio */
	//syncLoadAlertsAndAssets();
	/***************************  */

	$(".preloader").fadeOut();

	/* scrolling behavior  for all href scrolls */
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();

			var element = document.querySelector(this.getAttribute('href'))
			var headerOffset = 80;
			var elementPosition = element.getBoundingClientRect().top;
			var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});

		});
	});

});

/***** RESIZING with detection of done resizing every DELTAms ********/
var rtime;
var timeout = false;
var delta = 100;
$(window).resize(function () {
	if (typeof userassets !== undefined) {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	}
});

export function resizeend() {

	if (new Date() - rtime < delta) {
		setTimeout(resizeend, delta);
	} else {
		timeout = false;
		var ta = 0;
		if (typeof userassets !== 'undefined') {
			ta = userassets.length;
		}

		for (var i = 0; i <= ta; i++) {
			if ($("#visualization_" + i).height() > 0 && $('#1a' + i).hasClass("active")) {
				var __asset_id = userassets[i].id;
				var __el_id = i;
				var _ID = "none";
				graphsdata.forEach(function (el, ix) {
					if (el.asset_id == __asset_id) {
						_ID = ix;
					}
				})
				if (_ID != "none") {
					drawChartFor(__asset_id, __el_id);
				} else {
					updateGraph(__el_id);
				}
			}
		}
	}
}

/***** Subscriptions for Mobile App ********/
export function saveMobileSubscriptionAjax(ep, key, ti) {
	if (ep) {
		var senddata = {
			'endpoint': ep,
			'key': key,
			'auth': '0'
		}
		$.ajax({
			type: 'POST',
			url: "/save_pushsubscription",
			data: senddata,
			success: function (response) {
				console.log('Request succeeded with JSON response', response);
			},
			error: function (response) {
				console.log('Request failed', response);
			}
		});
		clearInterval(ti);
		var stringifiedMessageObj = JSON.stringify({ success: "yes" });
		webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	}
}

export function saveMobileSubscription(ep, key, refWin) {
	mobilesubscriptionsData.ep = ep;
	mobilesubscriptionsData.key = key;
}

export function cancelSubscriptionLoop() {
	clearInterval(refmobint);
}


export function callOnReady(functions) {
	var keys = Object.keys(functions)
	keys.forEach(function (_function) {
		var _arguments = functions[_function]
		window[_function](_arguments);
	})
}

export function callOnScroll(functions) {
	var keys = Object.keys(functions)
	keys.forEach(function (_function) {
		var _arguments = functions[_function]
		window.addEventListener("scroll", function (e) {
			window[_function](_arguments)
		});
	})
}


export function msieversion() {

	var ua = window.navigator.userAgent;
	var msie = ua.indexOf("MSIE ");

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
	{
		return (parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
	}
	else  // If another browser, return 0
	{
		return false;
	}

	return false;
}
